module.exports = "https://static.wmbcdn.com/uniweb/images/3cc89bd81960623af70168faf8f47537.svg";